import React, { useState, Suspense, useContext } from "react";
import { IconButton, Container, Divider, Grid, Typography, Box, Link } from "@mui/material";
import Draggable from "react-draggable";
import ConnectAccount from "./auth/ConnectToAccount";
import OpenDemoAccount from "./auth/OpenDemoAccount";
import { HiLink } from "react-icons/hi";
import { useTranslation } from 'react-i18next';
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import { ThemeContext } from "../../context/ThemeContext";
import CloseIcon from "@mui/icons-material/Close";
import UserName from "./auth/UserName";
import { useMediaQuery, useTheme } from "@mui/material";
import Login from "./Login/Login";

const TradingAccounts = ({ onClose }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("connect")
  const { darkMode } = useContext(ThemeContext)
  const handleTabChange = (tab) => setActiveTab(tab);
  // const storedName = localStorage.getItem('username')
  // const savedPassword = localStorage.getItem('password')
  const savedCredentials = JSON.parse(localStorage.getItem("savedCredentials") || "{}");

  const storedName = savedCredentials.username;
  const savedPassword = savedCredentials.password;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


  return (
    <>
      <Suspense fallback={<div>Loading translations...</div>}>
        <Container maxWidth={isMobile ? false : "md"}>
          <Draggable handle=".bg-primary">
            <div style={{ backgroundColor: darkMode ? '#0f1720' : 'var(--white)', boxShadow: darkMode ? "0px 16px 46px 8px rgba(0, 0, 0, 0.12)" : "0 10px 20px rgba(169, 169, 169, 0.3), 4px 4px 10px rgba(169, 169, 169, 0.2), -4px 4px 5px rgba(169, 169, 169, 0.1)", overflow: "hidden", width: "90%", position: "relative", }}>
              <div className="bg-primary" style={{ padding: "10px 15px", cursor: "move" }}>
                <Typography variant="body2" className="text-secondaryLight">{t('title')}: {process.env.REACT_APP_COMPANY_NAME}</Typography>
                {onClose && (
                  <IconButton size="small" onClick={onClose} style={{ position: "absolute", top: "8px", right: "8px", color: "var(--white)" }}>
                    <CloseIcon sx={{ fontSize: '18px' }} />
                  </IconButton>
                )}
              </div>

              <Grid container direction={isMobile ? 'column' : 'row'}>
                <Grid item xs={12} sm={4} style={{ borderRight: !isMobile ? `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` : "none", padding: isMobile ? "12px" : "0", display: "flex", flexDirection: isMobile ? "row" : "column", justifyContent: isMobile ? "center" : "flex-start", alignItems: isMobile ? "center" : "stretch", gap: isMobile ? "20px" : "0px" }}>
                  <Grid container wrap="nowrap" alignItems={isMobile ? "center" : "center"} spacing={1} sx={{ padding: isMobile ? 0 : '12px', width: isMobile ? 'auto' : '100%', flexWrap: isMobile ? 'nowrap' : 'wrap', }} >
                    <Grid item><HiLink style={{ color: "var(--primary)", fontSize: isMobile ? '1rem' : '1.4rem' }} /></Grid>
                    <Grid item><Typography variant={isMobile ? 'caption' : 'body2'} style={{ cursor: "pointer" }} onClick={() => handleTabChange("connect")} color={activeTab === "connect" ? "primary" : darkMode ? "var(--lightText)" : "var(--black)"}>{t('connectToAccount')}</Typography></Grid>
                  </Grid>
                  {isMobile ? null : (<Divider sx={{ borderColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)' }} />)}

                  <Grid container wrap="nowrap" alignItems={isMobile ? "flex-start" : "center"} spacing={1} sx={{ padding: isMobile ? 0 : '12px', width: isMobile ? 'auto' : '100%', flexWrap: isMobile ? 'nowrap' : 'wrap', }} >
                    <Grid item><PeopleAltTwoToneIcon style={{ color: "#2bbf53", fontSize: isMobile ? '1rem' : '1.4rem' }} /></Grid>
                    <Grid item><Typography variant={isMobile ? 'caption' : 'body2'} style={{ cursor: "pointer" }} onClick={() => handleTabChange("demo")} color={activeTab === "demo" ? "primary" : darkMode ? "var(--lightText)" : "var(--black)"}>{t('openDemoAccount')}</Typography></Grid>
                  </Grid>
                  {isMobile ? null : (<Divider sx={{ borderColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)' }} />)}

                  {!isMobile && storedName && savedPassword && (
                    <>
                      <Divider sx={{ borderColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)' }} />
                      <Grid container alignItems="center" spacing={1} sx={{ padding: "12px" }}>
                        <Grid item><PeopleAltTwoToneIcon style={{ color: "#ff8933", fontSize: '1.4rem' }} /></Grid>
                        <Grid item><Typography variant="body2" style={{ cursor: "pointer" }} onClick={() => handleTabChange("storedName")} color={activeTab === "storedName" ? "primary" : darkMode ? "var(--lightText)" : "var(--black)"}>{storedName}</Typography></Grid>
                      </Grid>
                      {isMobile ? null : (<Divider sx={{ borderColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)' }} />)}

                    </>

                  )}
                  {!isMobile && (<div style={{ position: "absolute", bottom: "10px", left: "10px", padding: '15px' }}>
                    <Box display='flex' flexDirection='column'>
                      <Typography variant="caption" className="text-gray1">2002-2025 Hybrid Solutions </Typography>
                      <Link href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target="_blank" variant="caption" className="text-primary" >{t('endUserAgreement')}</Link>
                      <Link href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" variant="caption" className="text-primary" >{t('privacyPolicy')}</Link>
                    </Box>
                  </div>)}
                </Grid>

                <Grid item xs={12} sm={8} style={{ padding: "12px", paddingBottom: '3px' }}>
                  {activeTab === "connect" && <ConnectAccount isMobile={isMobile} />}
                  {activeTab === "demo" && <OpenDemoAccount isMobile={isMobile} />}
                  {activeTab === "storedName" && <UserName isMobile={isMobile} />}

                  {isMobile && storedName && savedPassword && (
                    <Grid container alignItems="center" justifyContent="space-between" gap={1} sx={{ padding: !isMobile ? "12px" : "5px", border: `1px solid var(--primary)` }}>
                      <Grid container item xs alignItems="center" gap={1} wrap="nowrap">
                        <Grid item><PeopleAltTwoToneIcon style={{ color: "#ff8933", fontSize: isMobile ? '1rem' : '1.4rem' }} /></Grid>
                        <Grid item><Typography variant={isMobile ? 'caption' : 'body2'} style={{ cursor: "pointer" }} onClick={() => handleTabChange("storedName")} color={activeTab === "storedName" ? "primary" : darkMode ? "var(--lightText)" : "var(--black)"}>{storedName}</Typography></Grid>
                      </Grid>
                      <Grid item><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', backgroundColor: 'var(--primary)' }} /></Grid>
                    </Grid>
                  )}

                  {isMobile && (
                    <Box sx={{ padding: "12px", textAlign: 'center' }}>
                      <Typography variant="caption" className="text-gray1">2002-2025 Hybrid Solutions</Typography>
                      <Box>
                        <Link href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target="_blank" variant="caption" className="text-primary">{t('endUserAgreement')}</Link>{" "}
                        |{" "}
                        <Link href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" variant="caption" className="text-primary">{t('privacyPolicy')}</Link>
                      </Box>
                    </Box>
                  )}

                </Grid>
              </Grid>
            </div>
          </Draggable>
          <Login/>
        </Container>
      </Suspense>
    </>
  );
};

export default TradingAccounts;
